var _rect, _path, _path2, _path3, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobilePayWrapped(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 24,
    viewBox: "0 0 46 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.25879,
    y: 0.5,
    width: 44.2412,
    height: 23,
    rx: 5.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.27568 18C8.86519 18 8.49507 17.7529 8.33779 17.3737L4.83621 8.92064C4.62199 8.40342 4.86757 7.81047 5.38475 7.59617L9.0523 6.07721C9.30065 5.97429 9.57972 5.97426 9.82808 6.07714C10.0764 6.18002 10.2738 6.37736 10.3766 6.62575L13.8782 15.0791C14.092 15.5962 13.8465 16.1888 13.3296 16.4031L9.66208 17.9228C9.53961 17.9736 9.40831 17.9999 9.27568 18ZM9.44026 6.54537C9.3788 6.54547 9.31797 6.55771 9.26125 6.58138L5.59352 8.10035C5.47888 8.14784 5.38779 8.23893 5.34032 8.35359C5.29285 8.46824 5.29287 8.59706 5.34039 8.7117L8.84197 17.1653C8.94108 17.4038 9.21455 17.5171 9.45331 17.4186L13.1209 15.8986C13.2355 15.8511 13.3266 15.76 13.3741 15.6453C13.4215 15.5307 13.4215 15.4019 13.374 15.2872L9.87242 6.83451C9.79994 6.65974 9.62947 6.54569 9.44026 6.54537Z",
    fill: "#5A78FF"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7,
    d: "M10.6079 7.18275L10.1036 7.3916L11.49 10.7387L11.9943 10.5298L10.6079 7.18275Z",
    fill: "url(#paint0_linear_10013_24139)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7,
    d: "M13.141 14.7264L13.6453 14.5176L12.0759 10.7288L11.5717 10.9377L13.141 14.7264Z",
    fill: "url(#paint1_linear_10013_24139)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5045 12.2149C11.4556 12.6499 10.5798 13.2494 10.0064 13.9721L8.52795 10.4014C9.20233 9.61792 10.0607 9.01414 11.026 8.64428C12.0749 8.20935 13.1346 7.99884 14.0349 8.12149L15.5137 11.692C14.4828 11.6143 13.4488 11.794 12.5045 12.2149Z",
    fill: "#5A78FF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.9,
    d: "M12.5045 12.2149C11.4556 12.6499 10.5798 13.2494 10.0064 13.9721L8.52795 10.4014C9.20233 9.61792 10.0607 9.01414 11.026 8.64428C12.0749 8.20935 13.1346 7.99884 14.0349 8.12149L15.5137 11.692C14.4828 11.6143 13.4488 11.794 12.5045 12.2149Z",
    fill: "url(#paint2_linear_10013_24139)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7,
    d: "M12.5045 12.2149C11.4556 12.6499 10.5798 13.2494 10.0064 13.9721L8.52795 10.4014C9.20233 9.61792 10.0607 9.01414 11.026 8.64428C12.0749 8.20935 13.1346 7.99884 14.0349 8.12149L15.5137 11.692C14.4828 11.6143 13.4488 11.794 12.5045 12.2149Z",
    fill: "url(#paint3_linear_10013_24139)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.986 13.303C11.8507 13.303 10.8114 13.5224 10.0059 13.9702V10.3599C10.9287 9.89419 11.9527 9.66493 12.986 9.69268C14.1214 9.69268 15.1811 9.90319 15.966 10.3607V13.9711C15.0434 13.505 14.0194 13.2754 12.986 13.303ZM18.786 13.3063L19.7046 10.4027C19.7142 10.3624 19.7486 10.333 19.7898 10.3296H20.2508C20.2922 10.3354 20.327 10.3635 20.3413 10.4027L21.0563 12.2346C21.0703 12.2712 21.1068 12.2746 21.119 12.2346L21.8288 10.4027C21.8432 10.3635 21.8779 10.3354 21.9193 10.3296H22.3803C22.4215 10.333 22.4559 10.3624 22.4655 10.4027L23.3737 13.3063C23.3843 13.3287 23.3822 13.3549 23.3682 13.3753C23.3542 13.3958 23.3305 13.4072 23.3058 13.4055H22.7578C22.719 13.4072 22.6845 13.3808 22.676 13.3428L22.0932 11.457C22.0845 11.4204 22.0428 11.4204 22.0306 11.457L21.3347 13.3289C21.3229 13.374 21.2821 13.4054 21.2355 13.4055H20.9137C20.8632 13.4055 20.8371 13.3776 20.818 13.3289L20.1082 11.457C20.0943 11.4204 20.0577 11.4204 20.049 11.457L19.4523 13.3428C19.443 13.3818 19.407 13.4083 19.3671 13.4055H18.8451C18.8216 13.4051 18.8 13.3926 18.7879 13.3724C18.7758 13.3522 18.7751 13.3272 18.786 13.3063ZM23.5477 12.2625C23.5378 11.7678 23.8281 11.3163 24.2823 11.1201C24.7365 10.9239 25.2643 11.022 25.6176 11.3683C25.971 11.7146 26.0797 12.2403 25.8927 12.6983C25.7058 13.1564 25.2602 13.4558 24.7655 13.4559C24.4435 13.4669 24.1311 13.3455 23.901 13.12C23.6709 12.8945 23.5432 12.5846 23.5477 12.2625ZM25.357 12.2625C25.3352 11.9371 25.057 11.6891 24.7313 11.7047C24.4056 11.7203 24.1523 11.9937 24.1616 12.3196C24.1709 12.6455 24.4394 12.904 24.7655 12.9009C25.1041 12.8868 25.3672 12.6011 25.3535 12.2625H25.357ZM27.055 13.2176C27.0097 13.181 26.9697 13.195 26.9697 13.2576V13.3167C26.9698 13.3625 26.9337 13.4001 26.888 13.402H26.4635C26.4171 13.4002 26.38 13.3631 26.3782 13.3167V10.4131C26.38 10.3668 26.4171 10.3296 26.4635 10.3279H26.9106C26.9563 10.3297 26.9924 10.3674 26.9923 10.4131V11.2412C26.9923 11.3004 27.0324 11.3178 27.0967 11.2725C27.268 11.1443 27.476 11.0747 27.69 11.0742C28.3093 11.0742 28.7843 11.5961 28.7843 12.2677C28.7984 12.5745 28.6883 12.8741 28.4787 13.0987C28.2692 13.3233 27.9779 13.454 27.6708 13.4611C27.4425 13.4587 27.2232 13.3719 27.055 13.2176ZM28.1684 12.2677C28.1855 12.0436 28.0757 11.8288 27.884 11.7116C27.6923 11.5943 27.4511 11.5943 27.2594 11.7116C27.0677 11.8288 26.9578 12.0436 26.9749 12.2677C26.9688 12.43 27.0283 12.588 27.1398 12.7061C27.2514 12.8243 27.4058 12.8926 27.5682 12.8957C27.732 12.8921 27.8876 12.8231 28.0003 12.7042C28.113 12.5853 28.1736 12.4262 28.1684 12.2625V12.2677ZM29.1583 10.5401C29.1583 10.3479 29.3141 10.1922 29.5063 10.1922C29.6984 10.1922 29.8542 10.3479 29.8542 10.5401C29.8542 10.7323 29.6984 10.8881 29.5063 10.8881C29.3141 10.8881 29.1583 10.7323 29.1583 10.5401ZM29.1896 13.3237V11.2186C29.1896 11.1729 29.2257 11.1352 29.2714 11.1334H29.7185C29.7421 11.1324 29.765 11.1409 29.7823 11.1569C29.7996 11.1729 29.8098 11.1951 29.8107 11.2186V13.3167C29.8089 13.3631 29.7718 13.4002 29.7255 13.402H29.2714C29.2257 13.4001 29.1896 13.3625 29.1896 13.3167V13.3237ZM30.3083 12.6348V10.4131C30.3083 10.3674 30.3443 10.3297 30.3901 10.3279H30.8372C30.8835 10.3296 30.9206 10.3668 30.9224 10.4131V12.6487C30.9224 12.7931 30.9851 12.8888 31.1434 12.8888C31.166 12.8888 31.1877 12.8977 31.2036 12.9137C31.2196 12.9297 31.2286 12.9514 31.2286 12.974V13.3446C31.2267 13.3903 31.1891 13.4264 31.1434 13.4263C30.5484 13.4263 30.3083 13.2315 30.3083 12.6348ZM31.3956 12.2764C31.3972 11.8562 31.6228 11.4688 31.9874 11.26C32.3521 11.0513 32.8004 11.053 33.1635 11.2644C33.5266 11.4758 33.7493 11.8649 33.7478 12.2851C33.7478 12.3668 33.7251 12.4347 33.6434 12.4347H32.088C32.048 12.4347 32.0341 12.4573 32.0376 12.4938C32.0762 12.7664 32.3199 12.962 32.5943 12.941C32.7595 12.9434 32.9171 12.8719 33.024 12.7461C33.0572 12.6995 33.1112 12.6722 33.1684 12.673H33.5842C33.6573 12.673 33.6886 12.7235 33.6608 12.7948C33.4169 13.2921 32.8625 13.5557 32.3229 13.4312C31.7832 13.3067 31.4004 12.8267 31.3991 12.2729L31.3956 12.2764ZM33.0466 12.0676C33.078 12.0676 33.0919 12.0537 33.0867 12.0171C33.0393 11.7674 32.8189 11.5882 32.5647 11.5927C32.3162 11.5924 32.1001 11.7631 32.0428 12.005C32.0341 12.0363 32.0428 12.0676 32.0793 12.0676H33.0466ZM34.1235 13.3167V10.4131C34.1235 10.3674 34.1596 10.3297 34.2053 10.3279H35.6302C36.2808 10.3279 36.7245 10.7071 36.7245 11.3456C36.7245 11.9841 36.2217 12.3773 35.5988 12.3773H34.8438C34.8208 12.3749 34.798 12.3832 34.7821 12.3999C34.7661 12.4166 34.7587 12.4397 34.762 12.4625V13.3167C34.7602 13.3631 34.7231 13.4002 34.6768 13.402H34.2071C34.1607 13.401 34.1235 13.3631 34.1235 13.3167ZM35.5988 11.8519C35.8685 11.8434 36.0806 11.6188 36.0738 11.3491C36.0777 11.2214 36.0288 11.0977 35.9386 11.0071C35.8484 10.9166 35.7248 10.8673 35.5971 10.8707H34.8368C34.7829 10.8707 34.7603 10.8985 34.7603 10.9524V11.7753C34.7603 11.8293 34.7829 11.8571 34.8368 11.8571L35.5988 11.8519ZM36.9437 12.2625C36.9319 11.9548 37.0441 11.6552 37.255 11.4309C37.4659 11.2066 37.758 11.0762 38.0658 11.069C38.2879 11.0702 38.502 11.1525 38.6677 11.3004C38.7078 11.3369 38.753 11.3317 38.753 11.2778V11.2186C38.753 11.1734 38.7896 11.1368 38.8348 11.1368H39.2593C39.3056 11.1386 39.3427 11.1758 39.3445 11.2221V12.7148C39.3445 12.8279 39.3845 12.8783 39.4628 12.8888C39.5034 12.8896 39.5367 12.9213 39.5394 12.9618V13.355C39.5394 13.3973 39.5051 13.4316 39.4628 13.4316C39.1636 13.4316 38.9879 13.3463 38.8887 13.1741C38.8609 13.1288 38.8295 13.1201 38.7843 13.1654C38.5932 13.3621 38.3296 13.4716 38.0554 13.4681C37.7468 13.4591 37.455 13.3262 37.2457 13.0993C37.0365 12.8724 36.9276 12.5707 36.9437 12.2625ZM38.753 12.2625C38.7701 12.039 38.6606 11.8248 38.4694 11.7079C38.2783 11.591 38.0377 11.591 37.8466 11.7079C37.6554 11.8248 37.5459 12.039 37.563 12.2625C37.5459 12.4859 37.6554 12.7001 37.8466 12.817C38.0377 12.934 38.2783 12.934 38.4694 12.817C38.6606 12.7001 38.7701 12.4859 38.753 12.2625ZM39.7499 14.1988V13.8282C39.7517 13.7825 39.7894 13.7464 39.8351 13.7465C40.1262 13.7682 40.3946 13.5888 40.4858 13.3115C40.5011 13.2533 40.4949 13.1916 40.4684 13.1375L39.6368 11.2551C39.6224 11.2295 39.6229 11.1982 39.638 11.173C39.6531 11.1479 39.6805 11.1327 39.7099 11.1334H40.157C40.2022 11.1334 40.23 11.1699 40.2474 11.2151L40.7694 12.419C40.8059 12.5147 40.865 12.5095 40.9051 12.419L41.4026 11.2116C41.42 11.1664 41.4426 11.1386 41.4879 11.1386H41.9176C41.9444 11.1372 41.97 11.1496 41.9855 11.1715C42.0011 11.1933 42.0043 11.2216 41.9941 11.2464L41.1382 13.2715C40.8268 14.0092 40.4962 14.284 39.8351 14.284C39.7888 14.2822 39.7517 14.2451 39.7499 14.1988Z",
    fill: "#5A78FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.25879,
    y: 0.5,
    width: 44.2412,
    height: 23,
    rx: 5.5,
    stroke: "#CCCCCC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10013_24139",
    x1: 11.4031,
    y1: 9.83364,
    x2: 11.1767,
    y2: 7.19262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#504678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302,
    stopColor: "#504678",
    stopOpacity: 0.616
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.608,
    stopColor: "#504678",
    stopOpacity: 0.283
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#504678",
    stopOpacity: 0.076
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#504678",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10013_24139",
    x1: 12.2068,
    y1: 11.7399,
    x2: 12.3487,
    y2: 14.6991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#504678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302,
    stopColor: "#504678",
    stopOpacity: 0.616
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.608,
    stopColor: "#504678",
    stopOpacity: 0.283
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#504678",
    stopOpacity: 0.076
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#504678",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10013_24139",
    x1: 9.48514,
    y1: 11.9912,
    x2: 12.2555,
    y2: 10.1026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#504678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    stopColor: "#504678",
    stopOpacity: 0.872
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526,
    stopColor: "#504678",
    stopOpacity: 0.536
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#504678",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10013_24139",
    x1: 11.8618,
    y1: 10.145,
    x2: 11.739,
    y2: 9.16216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#504678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.643,
    stopColor: "#504678",
    stopOpacity: 0.332
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#504678",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilePayWrapped);
export default __webpack_public_path__ + "static/media/mobile-pay-wrapped.e1df391142a2e5cb2ca7049d5acc6220.svg";
export { ForwardRef as ReactComponent };